// What the first run offers to put on a new list ("What do you always buy?")
// and the stores it suggests ("Where do you shop?"). The staples are named in
// the phone's language (English or Swedish, the two the matcher reads) and
// each lands in its aisle through the keyword map, which the test checks. The
// stores are only suggestions for the phone's region; typing is always there.

import { BAKERY, DAIRY, FROZEN, HOUSEHOLD, PANTRY, PRODUCE } from './autocategory'

export interface Staple { en: string; sv: string; category: string }

/** How many staples can be picked: enough to fill the list, not the 15 Free allows. */
export const MAX_STAPLES = 12

export const STAPLES: Staple[] = [
  { en: 'Milk', sv: 'Mjölk', category: DAIRY },
  { en: 'Eggs', sv: 'Ägg', category: DAIRY },
  { en: 'Bananas', sv: 'Bananer', category: PRODUCE },
  { en: 'Bread', sv: 'Bröd', category: BAKERY },
  { en: 'Coffee', sv: 'Kaffe', category: PANTRY },
  { en: 'Butter', sv: 'Smör', category: DAIRY },
  { en: 'Cheese', sv: 'Ost', category: DAIRY },
  { en: 'Tomatoes', sv: 'Tomater', category: PRODUCE },
  { en: 'Pasta', sv: 'Pasta', category: PANTRY },
  { en: 'Yoghurt', sv: 'Yoghurt', category: DAIRY },
  { en: 'Apples', sv: 'Äpplen', category: PRODUCE },
  { en: 'Cucumber', sv: 'Gurka', category: PRODUCE },
  { en: 'Onions', sv: 'Lök', category: PRODUCE },
  { en: 'Potatoes', sv: 'Potatis', category: PRODUCE },
  { en: 'Avocado', sv: 'Avokado', category: PRODUCE },
  { en: 'Oat milk', sv: 'Havremjölk', category: DAIRY },
  { en: 'Chicken', sv: 'Kyckling', category: DAIRY },
  { en: 'Rice', sv: 'Ris', category: PANTRY },
  { en: 'Crispbread', sv: 'Knäckebröd', category: BAKERY },
  { en: 'Frozen peas', sv: 'Frysta ärtor', category: FROZEN },
  { en: 'Ice cream', sv: 'Glass', category: FROZEN },
  { en: 'Toilet paper', sv: 'Toalettpapper', category: HOUSEHOLD },
  { en: 'Dish soap', sv: 'Diskmedel', category: HOUSEHOLD },
]

const regionOf = (locale: string) => locale.split(/[-_]/)[1]?.toUpperCase() ?? ''
const swedish = (locale: string) => locale.toLowerCase().startsWith('sv') || regionOf(locale) === 'SE'

/** The staples' names, in the order offered, in the phone's language. */
export function staplesFor(locale: string): string[] {
  return STAPLES.map(s => (swedish(locale) ? s.sv : s.en))
}

const STORES: Record<string, string[]> = {
  SE: ['ICA', 'Coop', 'Willys', 'Lidl', 'Hemköp'],
  NO: ['Rema 1000', 'Kiwi', 'Coop', 'Meny'],
  DK: ['Netto', 'Føtex', 'Rema 1000', 'Lidl'],
  FI: ['K-Market', 'S-Market', 'Prisma', 'Lidl'],
  DE: ['Rewe', 'Edeka', 'Aldi', 'Lidl'],
  GB: ['Tesco', 'Sainsbury’s', 'Aldi', 'Lidl', 'Asda'],
  US: ['Trader Joe’s', 'Costco', 'Kroger', 'Whole Foods', 'Target'],
}

/** Stores worth a chip for the phone's region; none where we can't know. */
export function storeSuggestions(locale: string): string[] {
  return STORES[swedish(locale) && !regionOf(locale) ? 'SE' : regionOf(locale)] ?? []
}
